import jsonServerProvider from 'ra-data-json-server'
import axios from 'axios'
import legolasApi from '../api/legolas'

const dataProvider = jsonServerProvider('https://jsonplaceholder.typicode.com')
const customProvider = {
  ...dataProvider,
  getList: async (resource, params) => {
    let resourceFeed = {}
    if (resource == 'users' && typeof params.search == "undefined") {
      console.log('params: ', params)
      const currentPage = params.pagination.page
      const currentOffest = (currentPage - 1)*50
      const searchString = params.filter.q ? params.filter.q : ''
      let userData = await getUserData(currentOffest, searchString)
      let userObj = {}
      if (userData && userData.users) {
        userObj['data'] = userData.users
      }
      if (userData && userData.count) {
        userObj['total'] = userData.count
        localStorage.setItem('total-users', userData.count)
      }
      resourceFeed = userObj
    } else if (resource == 'users' && typeof params.search != "undefined") {
      let userData = await getFilteredUserData(params.search)
      let userObj = {}
      if (userData && userData.users) {
        userObj['data'] = userData.users
      }
      if (userData && userData.count) {
        userObj['total'] = userData.count
      }
      console.log('filtered: ', userData)
      console.log('curr userObj', userObj)
      resourceFeed = userObj
    } 
    console.log('res feed', resourceFeed)
    return resourceFeed
  }
}

async function getUserData(offset, search) {
  let retData = null
  await axios.get(`${legolasApi.url}/admin/users?offset=${offset}&limit=50&search=${search}`).then((response) => {
    if (response && response.data) {
      retData = response.data
    }
  })
  return retData
}
async function getFilteredUserData(query) {
  let retData = null
  await axios.get(`${legolasApi.url}/admin/users?search=${query}`).then((response) => {
    if (response && response.data) {
      retData = response.data
    }
  })
  return retData
}

export default customProvider